export const INSIGHTS_BILL_USAGE_ACTIONS = {
    USAGE_BILL_API_ERROR: "USAGE_BILL_API_ERROR",
    USAGE_BILL_DATA_NOT_AVAILABLE: "USAGE_BILL_DATA_NOT_AVAILABLE",
    USAGE_SAVE_YEAR_DATA: "USAGE_SAVE_YEAR_DATA",
    USAGE_SAVE_MONTH_DATA: "USAGE_SAVE_MONTH_DATA",
    USAGE_SAVE_DAY_DATA: "USAGE_SAVE_DAY_DATA",
    USAGE_SAVE_BILLING_CYCLE_PERIOD: "USAGE_SAVE_BILLING_CYCLE_PERIOD",
    USAGE_CHANGE_MODE: "USAGE_CHANGE_MODE",
    USAGE_CHANGE_GRAPH_STYLE: "USAGE_CHANGE_GRAPH_STYLE",
    USAGE_TOGGLE_FILTER_DROPDOWN: "USAGE_TOGGLE_FILTER_DROPDOWN",
    USAGE_TOGGLE_GAS_ELECTRIC: "USAGE_TOGGLE_GAS_ELECTRIC",
    USAGE_TOGGLE_COST_ENERGY: "USAGE_TOGGLE_COST_ENERGY",
    USAGE_TOGGLE_WEATHER: "USAGE_TOGGLE_WEATHER",
    USAGE_SET_HIGHCHARTS_DATA: "USAGE_SET_HIGHCHARTS_DATA",
    USAGE_CHANGE_YEAR_OFFSET: "USAGE_CHANGE_YEAR_OFFSET",
    USAGE_CHANGE_MONTH_OFFSET: "USAGE_CHANGE_MONTH_OFFSET",
    USAGE_CHANGE_DAY_OFFSET: "USAGE_CHANGE_DAY_OFFSET",
    USAGE_SET_ARROW_DISABLED: "USAGE_SET_ARROW_DISABLED",
    USAGE_FETCH_MONTH_FROM_YEAR: "USAGE_FETCH_MONTH_FROM_YEAR",
    USAGE_FETCH_DAY_FROM_MONTH: "USAGE_FETCH_DAY_FROM_MONTH",
    USAGE_UPDATE_HIGHCHARTS_OBJECT: "USAGE_UPDATE_HIGHCHARTS_OBJECT",
    USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER: "USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER",
    USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER: "USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER",
    USAGE_SET_MISSING_INTERVAL_DISCLAIMER: "USAGE_SET_MISSING_INTERVAL_DISCLAIMER",
    SET_NSM_CYCLE_DISCLAIMER: "SET_NSM_CYCLE_DISCLAIMER",
    USAGE_REMOVE_DISCLAIMERS: "USAGE_REMOVE_DISCLAIMERS",
    SET_DISCLAIMERS_VISIBILITY: "SET_DISCLAIMERS_VISIBILITY",
    RESET_DATA: "USAGE_RESET_DATA",
    SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE: "SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE",
    SET_DEFAULT_USAGE_DISPLAY_VALUE: "SET_DEFAULT_USAGE_DISPLAY_VALUE",
    SET_DETECTED_APPLIANCES: "SET_DETECTED_APPLIANCES",
    UPDATE_SELECTED_APPLIANCE : "UPDATE_SELECTED_APPLIANCE"
};

export function apiError(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_BILL_API_ERROR,
        payload
    }
}

export function dataNotAvailable(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_BILL_DATA_NOT_AVAILABLE,
        payload
    }
}

export function saveYearData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_YEAR_DATA,
        payload
    }
}

export function saveMonthData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_MONTH_DATA,
        payload
    }
}

export function saveDayData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_DAY_DATA,
        payload
    }
}

export function saveBillingCyclePeriod(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SAVE_BILLING_CYCLE_PERIOD,
        payload
    }
}

export function changeMode(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_MODE,
        payload
    }
}

export function changeGraphStyle(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_GRAPH_STYLE,
        payload
    }
}

export function toggleFilterFropdown(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_FILTER_DROPDOWN,
        payload
    }
}

export function toggleGasElectric(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_GAS_ELECTRIC,
        payload
    }
}

export function toggleCostEnergy(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_COST_ENERGY,
        payload
    }
}

export function toggleWeather(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_TOGGLE_WEATHER,
        payload
    }
}

export function setInsightsHighchartsData(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_HIGHCHARTS_DATA,
        payload
    }
}

export function changeYearOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_YEAR_OFFSET,
        payload
    }
}

export function changeMonthOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_MONTH_OFFSET,
        payload
    }
}

export function changeDayOffset(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_CHANGE_DAY_OFFSET,
        payload
    }
}

export function setArrowDisabled(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ARROW_DISABLED,
        payload
    }
}

export function fetchMonthBillingCycleFromYear(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_MONTH_FROM_YEAR,
        payload
    }
}

export function fetchDayBillingCycleFromMonth(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_FETCH_DAY_FROM_MONTH,
        payload
    }
}

export function updateHighChartsObject(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_UPDATE_HIGHCHARTS_OBJECT,
        payload
    }
}

export function setHasOngoingBillingCycle() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ONGOING_BILLING_CYCLE_DISCLAIMER
    }
}

export function setHasItemizationUnavailable() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_ITEMIZATION_UNAVAILABLE_DISCLAIMER
    }
}

export function setHasMissingInterval() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_SET_MISSING_INTERVAL_DISCLAIMER
    }
}

export function setHasNSMCycle() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.SET_NSM_CYCLE_DISCLAIMER
    }
}

export function removeDisclaimers() {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.USAGE_REMOVE_DISCLAIMERS
    }
}

export function setDisclaimersVisibility(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.SET_DISCLAIMERS_VISIBILITY,
        payload
    }
}

export function setPropsForCostOrConsumptionValues(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.SET_PROPS_FOR_COST_CONSUMPTION_TOGGLE,
        payload
    }
}

export function setDefaultUsageDisplayValue(payload) {
    return {
        type: INSIGHTS_BILL_USAGE_ACTIONS.SET_DEFAULT_USAGE_DISPLAY_VALUE,
        payload: payload
    }
}
export function setDetectedAppliances(payload){
  return{
    type: INSIGHTS_BILL_USAGE_ACTIONS.SET_DETECTED_APPLIANCES,
    payload
  }
}

export function updateSelectedAppliance(applianceId){
  return{
    type: INSIGHTS_BILL_USAGE_ACTIONS.UPDATE_SELECTED_APPLIANCE,
    payload: {selectedAppliance : applianceId}
  }
}
